export default __webpack_public_path__ + "static/media/plus_white_icon.8906aacf.svg";